export const MESSAGES = {
  FILTER_ADD: 'Filter by label values...',
  SELECT_LABEL: 'Select a label...',
  SELECT_OPERATOR: 'Select an operator...',
  SELECT_VALUE: 'Select a value...',
  SELECT_VALUES: 'Select values...',
  TYPE_VALUE: 'Type a regex...',
  LOADING: 'Loading...',
  ERROR_LOAD: 'An unexpected error occurred while loading! Please try again.',
  SUGGESTIONS_NONE: 'No suggestions available.',
  SUGGESTIONS_DISABLED: 'Suggestions are disabled for this label.',
};
